import { mdiDownload, mdiRefresh } from "@mdi/js";
import Icon from "@mdi/react";
import { debounce } from "lodash";
import moment from "moment";
import { FunctionComponent, useCallback, useEffect, useState } from "react";
import LoadingWidget from "../../../../context_providers/modal/loader";
import {
  ToastType,
  useToast,
} from "../../../../context_providers/toast/toast_ctx";
import { fetchGet, toQueryString } from "../../../../service/api_client";
import Pagination from "../../../../ui/new_components/common/pagination";
import { PoGeneratedModel } from "../../model/purchase_order_model";
import { useAuth } from "../../../../context_providers/auth/authProvider";

interface PoSnapSectionProps {
  po_no: string;
}

const PoSnapSection: FunctionComponent<PoSnapSectionProps> = (props) => {
  const { user } = useAuth();

  const [loading, setLoading] = useState(false);
  const { showToast } = useToast();
  const [showUpload, setShowUpload] = useState(false);
  const [snaps, setData] = useState<PoGeneratedModel[]>([]);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(50);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState("");

  useEffect(() => {
    if (!snaps || snaps.length === 0) {
      setShowUpload(true);
    }
  }, []);
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/purchase-order/${props.po_no}/snaps`;
  const fetchData = async (prop: {
    search?: string;
    page: number;
    count: number;
    all?: boolean;
  }) => {
    setLoading(true);
    try {
      const res = await fetchGet(url + toQueryString(prop));
      if (res.success) {
        setData(res.data.data);
        if (res.data.metadata) {
          setTotal(res.data.metadata.total);
        }
      } else {
        showToast({ type: ToastType.error, text: res.error });
      }
    } catch (error: any) {
      showToast({ type: ToastType.error, text: error.message });
    }
    setLoading(false);
  };
  const debouncedHandler = useCallback(
    debounce(
      (prop: {
        search?: string;
        page: number;
        count: number;
        all?: boolean;
      }) => {
        if (prop) fetchData(prop);
        else setData([]);
      },
      100,
    ),
    [],
  );

  useEffect(() => {
    debouncedHandler({ page, count, search });
  }, [page, search]);

  return (
    <>
      <div className="p-5 select-none">
        <div className="flex justify-end">
          <a
            href={url + "/generate"}
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              setTimeout(() => debouncedHandler({ page, count, search }), 3000);
            }}
            className="rounded-lg border px-3 py-1 text-sm flex items-center justify-center gap-1 "
          >
            <Icon path={mdiDownload} size={0.8}></Icon> Generate New PDF
          </a>
        </div>
        <div className="flex gap-1 mb-3">
          <h5 className="text-sm font-semibold ">History </h5>{" "}
          <button
            title="Refresh"
            onClick={() => debouncedHandler({ page, count, search })}
          >
            <Icon path={mdiRefresh} size={0.8}></Icon>
          </button>
        </div>

        <div className="grid grid-cols-7 text-sm font-semibold ">
          <div className="col-span-2">Purchase from (Vendor)</div>
          <div className="col-span-2">Total</div>
          <div className="col-span-2">Created by</div>
        </div>
        <div
          className="flex flex-col gap-1  overflow-auto w-full p-1 "
          style={{ height: "75vh" }}
        >
          {snaps &&
            snaps.length > 0 &&
            snaps.map((att, i) => (
              <div
                key={i}
                className="grid grid-cols-7 rounded-lg border   justify-center items-center text-xs p-2"
              >
                <div className="rounded-lg   col-span-2 flex justify-center items-center   ">
                  {att.party.name}
                </div>

                <div className=" col-span-2">{att.total}</div>
                <div className="flex flex-col justify-start   col-span-2">
                  <div className="">{att.created_by_name}</div>
                  <div className="italic " style={{ fontSize: 10 }}>
                    {moment(att.created_at).format("lll")}
                  </div>
                </div>

                <div className=" flex justify-center">
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={`${url}/download/${att._id}?auth=${user?.token}`}
                    className=" rounded-full p-1 flex justify-center items-center "
                  >
                    <Icon
                      path={mdiDownload}
                      size={0.8}
                      className="hover:scale-105 transform"
                    ></Icon>
                  </a>
                </div>
              </div>
            ))}
        </div>
        <Pagination
          page={page}
          total={total}
          count={count}
          itemCount={snaps.length}
          onChange={setPage}
        />
      </div>
      {loading && <LoadingWidget />}
    </>
  );
};

export default PoSnapSection;
